import * as fromUsuarioActions from './usuario-config.action';

export const initialState: any = {
  usuarioConfig: {},
};

export function reducer(
  state = initialState,
  action: fromUsuarioActions.UsuarioConfigActions
): any {
  switch (action.type) {
    case fromUsuarioActions.UsuarioConfigActionTypes.USER_CONFIG_ALL:
      return state;
    case fromUsuarioActions.UsuarioConfigActionTypes.USER_CONFIG_NEW:
      return (state = action.payload.userConfig);
    default:
      return state;
  }
}
